import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { caption } from '@ardoq/typography';
import { Box } from '@ardoq/layout';

export const InputHintMessage = styled(Box).attrs({
  marginTop: 'small',
})`
  ${caption};
  color: ${colors.textSubtle};
  overflow-wrap: anywhere;
`;
export const InputErrorMessage = styled(InputHintMessage)`
  color: ${colors.textError};
`;

export const InputWarningMessage = styled(InputHintMessage)`
  color: ${colors.textWarning};
`;
